import React from 'react';

export default function ReturnPolicy() {
  return (
    <>
      <style>{rpStyles}</style>

      <div className="rp-root">

        {/* ── HEADER ── */}
        <div className="rp-header">
          <div>
            <span className="rp-eyebrow">Last Updated · July 1, 2025</span>
            <h1 className="rp-title">Return &amp; <span className="rp-title-bold">Refund</span></h1>
          </div>
        </div>

        <div className="rp-rule-wrap"><hr className="rp-hr" /></div>

        {/* ── OVERVIEW STATS ── */}
        <div className="rp-stats">
          <div className="rp-stat">
            <span className="rp-stat-num">2–3</span>
            <span className="rp-stat-label">Days Return Window</span>
            <span className="rp-stat-sub">From date of receipt</span>
          </div>
          <div className="rp-stat-divider" />
          <div className="rp-stat">
            <span className="rp-stat-num">3–4</span>
            <span className="rp-stat-label">Business Days</span>
            <span className="rp-stat-sub">For refund processing</span>
          </div>
          <div className="rp-stat-divider" />
          <div className="rp-stat">
            <span className="rp-stat-num">24h</span>
            <span className="rp-stat-label">Support Response</span>
            <span className="rp-stat-sub">Via email</span>
          </div>
        </div>

        <div className="rp-rule-wrap"><hr className="rp-hr" /></div>

        {/* ── INTRO ── */}
        <div className="rp-intro-wrap">
          <p className="rp-intro">
            At <strong>VESHH-EON</strong>, we believe in helping our customers as far as possible. Our return and refund policy is designed to ensure your complete satisfaction with every purchase.
          </p>
        </div>

        <div className="rp-rule-wrap"><hr className="rp-hr" /></div>

        {/* ── SECTIONS ── */}
        <div className="rp-sections">

          {/* 01 — Cancellation */}
          <section className="rp-section">
            <div className="rp-section-meta">
              <span className="rp-section-num">01</span>
              <div>
                <span className="rp-section-eyebrow">Policy</span>
                <h2 className="rp-section-title">Cancellation <span className="rp-section-bold">Policy</span></h2>
              </div>
            </div>
            <div className="rp-section-body">
              <div className="rp-item">
                <span className="rp-item-label">Timing</span>
                <p className="rp-item-text">Cancellations will be considered only if requested within <strong>2–3 days of placing the order</strong>.</p>
              </div>
              <div className="rp-item">
                <span className="rp-item-label">Processing Status</span>
                <p className="rp-item-text">Cancellation requests may not be entertained if orders have been communicated to vendors or merchants and shipping has been initiated.</p>
              </div>
              <div className="rp-item">
                <span className="rp-item-label">Quality Issues</span>
                <p className="rp-item-text">Refund or replacement is available if product quality is found to be compromised.</p>
              </div>
            </div>
          </section>

          <div className="rp-rule-wrap"><hr className="rp-hr" /></div>

          {/* 02 — Return */}
          <section className="rp-section">
            <div className="rp-section-meta">
              <span className="rp-section-num">02</span>
              <div>
                <span className="rp-section-eyebrow">Conditions</span>
                <h2 className="rp-section-title">Return <span className="rp-section-bold">Policy</span></h2>
              </div>
            </div>
            <div className="rp-section-body">
              <div className="rp-item">
                <span className="rp-item-label">Damaged or Defective Items</span>
                <p className="rp-item-text">Report damaged or defective items to our Customer Service team immediately. Must be reported within <strong>2–3 days of receipt</strong>. Request will be processed after merchant verification.</p>
              </div>
              <div className="rp-item">
                <span className="rp-item-label">Product Not As Expected</span>
                <p className="rp-item-text">If the product is not as shown on the site or doesn't meet expectations, notify our customer service within <strong>2–3 days of receiving</strong> the product. Our team will review and take appropriate action.</p>
              </div>
            </div>
          </section>

          <div className="rp-rule-wrap"><hr className="rp-hr" /></div>

          {/* 03 — Refund Process */}
          <section className="rp-section">
            <div className="rp-section-meta">
              <span className="rp-section-num">03</span>
              <div>
                <span className="rp-section-eyebrow">Timeline</span>
                <h2 className="rp-section-title">Refund <span className="rp-section-bold">Process</span></h2>
              </div>
            </div>
            <div className="rp-section-body">
              <p className="rp-pull">
                "Approved refunds processed within 3–4 business days to your original payment method."
              </p>
              <div className="rp-item">
                <span className="rp-item-label">Processing Time</span>
                <p className="rp-item-text">Once your refund is approved by VESHH-EON, it will take <strong>3–4 business days</strong> for the refund to be processed to your original payment method.</p>
              </div>
            </div>
          </section>

          <div className="rp-rule-wrap"><hr className="rp-hr" /></div>

          {/* 04 — How to Request */}
          <section className="rp-section">
            <div className="rp-section-meta">
              <span className="rp-section-num">04</span>
              <div>
                <span className="rp-section-eyebrow">Steps</span>
                <h2 className="rp-section-title">How To <span className="rp-section-bold">Request</span></h2>
              </div>
            </div>
            <div className="rp-section-body">
              {[
                "Contact our Customer Service team within 2–3 days of receiving your order.",
                "Provide your order details and reason for return.",
                "Our team will review your request and provide further instructions.",
                "Once approved, your refund will be processed within 3–4 business days.",
              ].map((step, i) => (
                <div key={i} className="rp-step">
                  <span className="rp-step-num">0{i + 1}</span>
                  <p className="rp-step-text">{step}</p>
                </div>
              ))}
            </div>
          </section>

          <div className="rp-rule-wrap"><hr className="rp-hr" /></div>

          {/* 05 — Important Notes */}
          <section className="rp-section">
            <div className="rp-section-meta">
              <span className="rp-section-num">05</span>
              <div>
                <span className="rp-section-eyebrow">Please Note</span>
                <h2 className="rp-section-title">Important <span className="rp-section-bold">Notes</span></h2>
              </div>
            </div>
            <div className="rp-section-body">
              {[
                "All return requests are subject to verification and approval by our team.",
                "Products must be in original condition with all tags and packaging intact.",
                "Custom or personalized items may not be eligible for returns.",
                "This policy is subject to change. Please check for updates regularly.",
              ].map((note, i) => (
                <div key={i} className="rp-note">
                  <span className="rp-note-dash">—</span>
                  <p className="rp-note-text">{note}</p>
                </div>
              ))}
            </div>
          </section>

        </div>

        {/* ── CONTACT STRIP ── */}
        <div className="rp-rule-wrap"><hr className="rp-hr" /></div>
        <div className="rp-contact">
          <div className="rp-contact-left">
            <span className="rp-contact-eyebrow">Need Help?</span>
            <span className="rp-contact-title">We're Here For You</span>
          </div>
          <a href="mailto:support@veshheon.in" className="rp-contact-email">
            support@veshheon.in
            <span className="rp-contact-note">Response within 24 hours</span>
          </a>
        </div>

        {/* ── CLOSING ── */}
        <div className="rp-rule-wrap"><hr className="rp-hr" /></div>
        <div className="rp-closing">
          <span className="rp-closing-text">VESHH-EON · Return &amp; Refund Policy · July 2025</span>
        </div>

      </div>
    </>
  );
}

const rpStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Exo+2:wght@200;300;400;500;600&display=swap');

  .rp-root {
    background: #f8f8f8;
    min-height: 100vh;
    font-family: 'Exo 2', sans-serif;
    padding-bottom: 80px;
  }

  /* ── HEADER ── */
  .rp-header {
    max-width: 1200px;
    margin: 0 auto;
    padding: 64px 80px 40px;
  }

  .rp-eyebrow {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.5em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 12px;
  }
  .rp-eyebrow::before {
    content: '';
    width: 24px;
    height: 1px;
    background: black;
    display: block;
    flex-shrink: 0;
  }

  .rp-title {
    font-size: clamp(32px, 4.5vw, 60px);
    font-weight: 200;
    color: #000;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
  }
  .rp-title-bold { font-weight: 600; }

  /* ── RULES ── */
  .rp-rule-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }
  .rp-hr {
    border: none;
    border-top: 1px solid black;
    margin: 0;
  }

  /* ── STATS ── */
  .rp-stats {
    max-width: 1200px;
    margin: 0 auto;
    padding: 52px 80px;
    display: flex;
    align-items: center;
    gap: 0;
  }

  .rp-stat {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0 40px;
  }
  .rp-stat:first-child { padding-left: 0; }
  .rp-stat:last-child  { padding-right: 0; }

  .rp-stat-num {
    font-size: clamp(36px, 4vw, 56px);
    font-weight: 200;
    color: #000;
    letter-spacing: -0.02em;
    line-height: 1;
  }

  .rp-stat-label {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    color: #000;
  }

  .rp-stat-sub {
    font-size: 9px;
    font-weight: 300;
    letter-spacing: 0.2em;
    color: black;
    text-transform: uppercase;
  }

  .rp-stat-divider {
    width: 1px;
    height: 60px;
    background: black;
    flex-shrink: 0;
  }

  /* ── INTRO ── */
  .rp-intro-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 80px;
  }

  .rp-intro {
    font-size: 15px;
    font-weight: 300;
    color: black;
    line-height: 2;
    letter-spacing: 0.04em;
    max-width: 680px;
  }

  /* ── SECTIONS ── */
  .rp-sections {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }

  .rp-section {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 60px;
    padding: 56px 0;
  }

  /* Left meta */
  .rp-section-meta {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .rp-section-num {
    font-size: 64px;
    font-weight: 200;
    color: black;
    line-height: 1;
    letter-spacing: -0.02em;
  }

  .rp-section-eyebrow {
    display: block;
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: rgba(0,0,0,0.3);
    margin-bottom: 8px;
  }

  .rp-section-title {
    font-size: clamp(20px, 2.5vw, 32px);
    font-weight: 200;
    color: #000;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
  }
  .rp-section-bold { font-weight: 600; }

  /* Right body */
  .rp-section-body {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-top: 4px;
  }

  /* Item */
  .rp-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-bottom: 20px;
    border-bottom: 1px solid black;
  }
  .rp-item:last-child { border-bottom: none; padding-bottom: 0; }

  .rp-item-label {
    font-size: 8px;
    font-weight: 500;
    letter-spacing: 0.4em;
    text-transform: uppercase;
    color: black;
  }

  .rp-item-text {
    font-size: 13px;
    font-weight: 300;
    color: black;
    line-height: 2;
    letter-spacing: 0.03em;
    text-align: justify;
    margin: 0;
  }

  /* Pull quote */
  .rp-pull {
    font-size: 15px;
    font-weight: 300;
    font-style: italic;
    color: black;
    line-height: 1.7;
    border-left: 2px solid black;
    padding-left: 18px;
    margin: 0;
    letter-spacing: 0.02em;
  }

  /* Steps */
  .rp-step {
    display: flex;
    align-items: flex-start;
    gap: 20px;
  }

  .rp-step-num {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2em;
    color: black;
    flex-shrink: 0;
    padding-top: 2px;
  }

  .rp-step-text {
    font-size: 13px;
    font-weight: 300;
    color: rgba(0,0,0,0.6);
    line-height: 2;
    letter-spacing: 0.03em;
    margin: 0;
  }

  /* Notes */
  .rp-note {
    display: flex;
    align-items: flex-start;
    gap: 14px;
  }

  .rp-note-dash {
    font-size: 13px;
    font-weight: 300;
    color: black;
    flex-shrink: 0;
    padding-top: 2px;
  }

  .rp-note-text {
    font-size: 13px;
    font-weight: 300;
    color: black;
    line-height: 2;
    letter-spacing: 0.03em;
    margin: 0;
    text-align: justify;
  }

  /* ── CONTACT STRIP ── */
  .rp-contact {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }

  .rp-contact-left {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .rp-contact-eyebrow {
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
  }

  .rp-contact-title {
    font-size: clamp(18px, 2.5vw, 28px);
    font-weight: 200;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #000;
  }

  .rp-contact-email {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    text-decoration: none;
  }

  .rp-contact-email > span:first-child {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.08em;
    color: #000;
    position: relative;
    padding-bottom: 3px;
  }
  .rp-contact-email > span:first-child::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0;
    width: 100%;
    height: 1px;
    background: black;
    transition: background 0.25s ease;
  }
  .rp-contact-email:hover > span:first-child::after {
    background: #000;
  }

  .rp-contact-note {
    font-size: 8px;
    font-weight: 300;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: black;
  }

  /* ── CLOSING ── */
  .rp-closing {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px 80px 0;
    text-align: center;
  }

  .rp-closing-text {
    font-size: 8px;
    font-weight: 300;
    letter-spacing: 0.4em;
    text-transform: uppercase;
    color: black;
  }

  /* ── RESPONSIVE ── */
  @media (max-width: 1024px) {
    .rp-header   { padding: 48px 40px 32px; }
    .rp-rule-wrap { padding: 0 40px; }
    .rp-stats    { padding: 40px 40px; }
    .rp-stat     { padding: 0 24px; }
    .rp-intro-wrap { padding: 40px 40px; }
    .rp-sections { padding: 0 40px; }
    .rp-contact  { padding: 40px 40px; }
    .rp-closing  { padding: 20px 40px 0; }
  }

  @media (max-width: 768px) {
    .rp-header   { padding: 40px 20px 28px; }
    .rp-rule-wrap { padding: 0 20px; }
    .rp-stats    { padding: 36px 20px; flex-direction: column; align-items: flex-start; gap: 28px; }
    .rp-stat     { padding: 0; }
    .rp-stat-divider { width: 40px; height: 1px; }
    .rp-intro-wrap { padding: 36px 20px; }
    .rp-sections { padding: 0 20px; }
    .rp-section  { grid-template-columns: 1fr; gap: 20px; padding: 40px 0; }
    .rp-section-meta { flex-direction: row; align-items: flex-end; gap: 16px; }
    .rp-section-num  { font-size: 44px; }
    .rp-contact  { flex-direction: column; align-items: flex-start; padding: 36px 20px; gap: 20px; }
    .rp-contact-email { align-items: flex-start; }
    .rp-closing  { padding: 20px 20px 0; }
  }

  @media (max-width: 360px) {
    .rp-header   { padding: 32px 14px 24px; }
    .rp-rule-wrap { padding: 0 14px; }
    .rp-stats    { padding: 28px 14px; }
    .rp-intro-wrap { padding: 28px 14px; }
    .rp-sections { padding: 0 14px; }
    .rp-contact  { padding: 28px 14px; }
    .rp-closing  { padding: 16px 14px 0; }
  }
`;
